import type { UIMessage } from 'ai';
import { CopilotThread } from '@/features/copilot';
import { InternalNotesTab } from '@/features/internal-notes';
import { ProposedActionsPlanView } from '@/features/proposed-actions-plan';

type CopilotChatStatus = 'ready' | 'submitted' | 'streaming' | 'error';

interface CopilotContentOutletProps {
  activeTab?: string;
  messages: UIMessage[];
  status: CopilotChatStatus;
}

export function CopilotContentOutlet({
  activeTab = 'copilot',
  messages,
  status,
}: CopilotContentOutletProps) {
  switch (activeTab) {
    case 'notepad':
      return <InternalNotesTab />;

    default:
      if (messages.length === 0 && status === 'ready') {
        return (
          <div className="h-full overflow-y-auto px-2 pt-3">
            <h2 className="mb-2 bg-gradient-to-r from-foreground/70 to-foreground/30 bg-clip-text px-1.5 text-sm font-normal text-transparent">
              Suggested Care Actions
            </h2>
            <ProposedActionsPlanView />
          </div>
        );
      }
      return <CopilotThread className="h-full" messages={messages} status={status} />;
  }
}
